import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import List from './List'

const Tickets: React.FC = ({}) => {
  const { path } = useRouteMatch()

  return (
    <>
      <Switch>
        <Route path={path + '/'}>
          <List />
        </Route>
        <Redirect from={path} to={path + '/'} />
      </Switch>
    </>
  )
}

export default Tickets
